import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import { OrganizationSchema, WebSiteSchema, WebPageSchema, FAQPageSchema } from '@/components/feature/SchemaOrg';
import { faqs } from '@/mocks/siteData';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import CategoriesPreview from './components/CategoriesPreview';
import ArticlesPreview from './components/ArticlesPreview';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <OrganizationSchema />
      <WebSiteSchema />
      <WebPageSchema
        title="开云官网 - 官方正版入口，安全登录体验"
        description="开云官网是您访问开云平台的官方正版渠道，提供安全稳定的登录入口、丰富的产品服务与极致用户体验。"
        url="https://www.kaiyun.com/"
      />
      <FAQPageSchema faqs={faqs} />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main>
          <HeroSection />
          <FeaturesSection />
          <CategoriesPreview />
          <ArticlesPreview />
          <FAQSection />
          <CTASection />
        </main>

        <Footer />
      </div>
    </>
  );
}